// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"e60592fd","213":"c5503dea","239":"b2147fc1"}[chunkId] + ".chunk.js";
};